import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'

type ContentItem = {
    title: string
    description: string
    direction: 'row' | 'column'
}

const EventDetails = () => {
    const { translate } = useTranslate()
    const contents: ContentItem[] = [
        {
            title: `${translate('physical_check_in')}:`,
            description: translate('physical_check_in_description'),
            direction: 'column'
        },
        {
            title: `${translate('schedule')}:`,
            description: translate('schedule_description'),
            direction: 'column'
        },
        {
            title: `${translate('dress_code')}:`,
            description: translate('dress_code_description'),
            direction: 'row'
        }
    ]

    const dates = [
        {
            month: translate('glic2027_month_1'),
            day: translate('glic2027_date_1'),
            dayName: translate('glic2027_day_1'),
            time: `${translate('glic2027_event_start_at_1')}`
        },
        {
            month: translate('glic2027_month_2'),
            day: translate('glic2027_date_2'),
            dayName: translate('glic2027_day_2'),
            time: `${translate('glic2027_event_start_at_2')}`
        }
    ]

    return (
        <Stack bgcolor={'primary.main'} gap={3} p={'48px 24px'}>
            <Typography variant="h1" color="secondary.light" textTransform={'uppercase'}>
                {translate('event_details')}
            </Typography>
            <Stack gap={3}>
                {contents.map(content => (
                    <Stack key={content.title} flexDirection={content.direction}>
                        <Typography variant="body1" color="secondary.light" fontWeight={700}>
                            {content.title}
                        </Typography>
                        <Typography variant="body1" color="secondary.light">
                            {content.direction === 'row' ? <>&nbsp;</> : ''}
                            {content.description}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
            <Stack
                flex={1}
                bgcolor={'secondary.main'}
                sx={{
                    borderTopRightRadius: '100px',
                    borderBottomLeftRadius: '100px',
                    padding: '40px',
                    '@media (max-width: 390px)': {
                        paddingRight: '18px'
                    }
                }}>
                {dates.map((date, index) => (
                    <Stack direction={'column'} key={date.day}>
                        <Stack direction={'row'} gap={'10px'} alignItems={'center'}>
                            <Typography variant="h1" color="primary.light" fontSize={'30px'} fontWeight={400}>
                                {date.month}
                            </Typography>
                        </Stack>
                        <Stack direction={'row'} gap={'10px'} alignItems={'center'}>
                            <Typography variant="body1" fontSize={'46px'} fontWeight={700} lineHeight={1} color="warning.main">
                                {date.day}
                            </Typography>
                            <Stack>
                                <Typography variant="body1" color="primary.main" lineHeight={1} fontWeight={700}>
                                    {date.dayName}
                                </Typography>
                                <Typography variant="body1" color="primary.main">
                                    {date.time}
                                </Typography>
                            </Stack>
                        </Stack>
                        {index !== dates.length - 1 && <Divider sx={{ marginTop: '28px', marginBottom: '28px', borderColor: 'primary.light' }} />}
                    </Stack>
                ))}
            </Stack>
        </Stack>
    )
}

export default EventDetails
